import gql from 'graphql-tag'
import {
	category as categoryFragment,
	surcharge as surchargeFragment,
	options as optionsFragment
} from './fragments'

export const category = gql`
mutation CpdateCategory_Main($id: ID!, $fields: CategoryFields!) {
	cashAssist {
		updateCategory(id: $id, fields: $fields) {
			id
			mod_ver
			...categorymain
		}
	}
}
${categoryFragment}`

export const cashRegisters = gql`
mutation updateCategory_cashRegisters($id: ID!, $fields: CategoryFields!) {
	cashAssist {
	  updateCategory(id: $id, fields: $fields) {
	    id
	    mod_ver
	    cashRegisterId
	  }
	 }
}
`

export const surcharge = gql`
mutation updateCategory_Surcharge($id: ID!, $fields: CategoryFields!) {
	cashAssist {
		updateCategory(id: $id, fields: $fields) {
			id
			mod_ver
			...categorySurcharge
		}
	}
}
${surchargeFragment}`

export const options = gql`
mutation updateCategory_Options($id: ID!, $fields: CategoryFields!) {
	cashAssist {
		updateCategory(id: $id, fields: $fields) {
			id
			mod_ver
			...categoryOptions
		}
	}
}
${optionsFragment}`

export const concepts = gql`
mutation updateCategory_Concept($id: ID!, $fields: CategoryFields!) {
	cashAssist {
		updateCategory(id: $id, fields: $fields) {
			id
			mod_ver
			name
			concepts
		}
	}
}`

export default {
	category,
	cashRegisters,
	surcharge,
	options,
	concepts
}
